const DATE_TOKEN_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const SUPPORTED_PRESETS = ["Today", "Yesterday", "7D", "30D", "This Month"];

/**
 * True only for the "historical" date filters: 7D, This Month, and custom date range.
 * Today, Yesterday, and 30D are intentionally excluded.
 */
export const isHistoricalReportDateFilter = (value: unknown): boolean => {
    if (typeof value !== "string" || !value) return false;
    if (value === "7D" || value === "This Month") return true;
    return value.startsWith("custom:");
};

export const isSupportedReportDateFilter = (value: unknown): boolean => {
    if (typeof value !== "string" || !value) return false;
    if (SUPPORTED_PRESETS.includes(value)) return true;
    if (!value.startsWith("custom:")) return false;
    const parts = value.split(":");
    if (parts.length !== 3) return false;
    const from = parts[1];
    const to = parts[2];
    return DATE_TOKEN_REGEX.test(from) && DATE_TOKEN_REGEX.test(to) && from <= to;
};

/**
 * @param {string} [fallback="7D"]
 * @param {{ excludeToday?: boolean }} [opts] - If true, when saved value is "Today" return fallback instead (for reports that hide Today).
 */
export const getInitialReportDateFilter = (fallback = "Today", opts: { excludeToday?: boolean } = {}): string => {
    // Always honor page-defined default (first option) on initial load.
    if (opts.excludeToday && fallback === "Today") return "Yesterday";
    return fallback;
};

const toDdMmYyyy = (iso: string): string => {
    const [y, m, d] = iso.split("-");
    return `${d}-${m}-${y}`;
};

/**
 * Builds the date portion of an export filename from the active report date filter.
 * Presets (Today, Yesterday, 7D, ...) are slugified as before; a "custom:from:to"
 * value renders as "DD-MM-YYYY to DD-MM-YYYY" so exported files show the actual range.
 */
export const formatDateFilterForFilename = (activeDate: string): string => {
    if (activeDate.startsWith("custom:")) {
        const [, from, to] = activeDate.split(":");
        return `${toDdMmYyyy(from)} to ${toDdMmYyyy(to)}`;
    }
    return activeDate.replace(/\s+/g, "-").toLowerCase();
};

